<template>
    <div>
        <template v-if="crud_company === true">
            <div class="page-top mb-1 mb-3">
                <h1> Add User Details </h1>
            </div>
            <div class="global-main p-0">
                <div class="modal fade" id="finish_onboarding_modal" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                        <div class="modal-body">
                            <div class="modal-body login-mobilizer text-left">
                                <div class="login-mobilizer-inner" style="text-align: center!important;">
                                    <img class="logo mb-3" src="/images/success-icon.png" alt="" />
                                    <div class="moblizer-account-detail">
                                        <label class="label block-label"> <b>Submitted Successfully!</b> </label>
                                        <label class="label block-label" id="finish_onboarding_modal_text"></label>
                                        <div class="row normal-ib-space mt-3">
                                            <div class="col"> <button class="btn btn-primary float-right mr-2" onclick="$('#logout-form').submit()"> Logout </button> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="new_user_created_before_approval" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                        <div class="modal-body">
                            <div class="modal-body login-mobilizer text-left">
                                <div class="login-mobilizer-inner" style="text-align: center!important;">
                                    <img class="logo mb-3" src="/images/success-icon.png" alt="" />
                                    <div class="moblizer-account-detail">
                                        <label class="label block-label"> <b>New User Created Successfully!</b> </label>
                                        <label class="label block-label" id="new_user_created_before_approval_text"></label>
                                        <div class="normal-ib-space mt-3">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">OK</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade onboarding-modal" id="popupModal" tabindex="-1" role="dialog" aria-labelledby="popupModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body" style="align-self:center">
                                <img :src="popup_image_path" alt="" style="width:400px;height:400px;">
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-primary" @click="downloadImg(popup_image_path)">Download</button>
                            </div>
                        </div>
                    </div>    
                </div>
                <div class="onboarding-form-outer">
                    <div class="onboarding-main">
                        <div class="container">
                            <div class="onboarding-top-steps">
                                <ul class="clearfix onb-steps-list">
                                    <li class="complete-li"> <span class="completed"> <img src="/images/tick-white.png" alt=""> </span> Company Details </li>
                                    <li class="complete-li"> <span class="completed"> <img src="/images/tick-white.png" alt=""> </span> Required Documents </li>
                                    <li class="complete-li"> <span class="completed"> <img src="/images/tick-white.png" alt=""> </span> User Details </li>
                                </ul>
                            </div>
                            <div class="onboarding-form">
                                <div class="form-title"><u>Users Details</u>
                                    <button type="submit" class="btn-submit float-right mb-2" id="add_user_modal_btn" data-toggle="modal" data-target="#add_new_user_modal">Add New User</button>
                                </div>
                                <br>
                                
                                    <input type="hidden" name="hidden1" id="hidden1" value="" required>
                                    <input type="hidden" name="hidden2" id="hidden2" value="" required>

                                    <div v-for="(company_user,index) in company_users" :id="'accordian'+company_user.user_id" class="accordian" v-bind:key="company_user.user_id">
                                        <div class="card">
                                            <div class="card-header" id="headingOne">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" data-toggle="collapse" :data-target="'#firstperson'+company_user.user_id" aria-expanded="true" :aria-controls="'firstperson'+company_user.user_id">
                                                {{ index+1 }}. {{ company_user.user_name }} <span> {{company_user.role}}  </span> <i class="fas fa-chevron-up"></i> <i class="fas fa-chevron-down"></i>
                                                </button>
                                            </h5>
                                            </div>

                                            <div :id="'firstperson'+company_user.user_id" class="collapse" aria-labelledby="headingOne" :data-parent="'#accordian'+company_user.user_id">
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <select class="custom-select" name="person" disabled>
                                                            <option value="Maker" :selected="company_user.role == 'Maker'">Maker</option>
                                                            <option value="Checker" :selected="company_user.role == 'Checker'">Checker 1</option>
                                                            <option value="Approver" :selected="company_user.role == 'Approver'">Approver</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <input type="text" placeholder="Name" class="form-control" readonly :value="company_user.user_name">
                                                        <label for="" class="absolute-label">Name</label>
                                                    </div>
                                                    <div class="form-group">
                                                        <input type="text" placeholder="CNIC" class="form-control" readonly :value="company_user.user_cnic">
                                                        <label for="" class="absolute-label">CNIC</label>
                                                    </div>
                                                    <div class="form-group">
                                                        <input type="text" placeholder="Contact Number" class="form-control" readonly :value="company_user.user_mobile_no">
                                                        <label for="" class="absolute-label">Contact Number</label>
                                                    </div>
                                                    <div class="form-group">
                                                        <input type="email" placeholder="Email" class="form-control" readonly :value="company_user.user_email">
                                                        <label for="" class="absolute-label">Email</label>
                                                    </div>
                                                    <div class="row cnic-holder">
                                                        <div class="col-6">
                                                            <figure class="text-center">
                                                                <figcaption>CNIC Front Side</figcaption>
                                                                <div v-if="company_user.cnic_front_path !== null" class="img-outer" @click="view_image(cnic_bucket_path+company_user.cnic_front_path)">
                                                                    <img :src="cnic_bucket_path+company_user.cnic_front_path" alt="CNIC Front side" style="width:128px;height:128px;">
                                                                </div>
                                                                <div v-else class="text-danger">
                                                                    CNIC Front side not uploaded
                                                                </div>
                                                                <!-- <img :src="cnic_bucket_path+company_user.cnic_front_path" alt="CNIC Front side" style="width:128px;height:128px;"> -->
                                                            </figure>
                                                        </div>
                                                        <div class="col-6">
                                                            <figure class="text-center">
                                                                <figcaption>CNIC Back Side</figcaption>
                                                                <!-- <img :src="cnic_bucket_path+company_user.cnic_back_path" alt="CNIC Back side" style="width:128px;height:128px;"> -->
                                                                <div v-if="company_user.cnic_back_path !== null" class="img-outer" @click="view_image(cnic_bucket_path+company_user.cnic_back_path)">
                                                                    <img :src="cnic_bucket_path+company_user.cnic_back_path" alt="CNIC Back side" style="width:128px;height:128px;">
                                                                </div>
                                                                <div v-else class="text-danger">
                                                                    CNIC Back side not uploaded
                                                                </div>
                                                            </figure>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div style="clear:both;"></div>
                                    
                                    <div class="modal fade" id="add_new_user_modal" data-backdrop="static" data-keyboard="false">
                                        <div class="modal-dialog modal-dialog-centered modal-lg">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <div class="form-title mt-2"><u>Add new User</u></div>
                                                </div>
                                                <div class="modal-body">
                                                    <form id="userForm" @submit.prevent="addCompanyUsers" novalidate>
                                                        <div class="form-group">
                                                            <label> Select Role </label>
                                                            <select v-model="form.user_role" data-live-search="true" name="user_role" class="selectpicker custom-select2 form-control p-0" :class="{ 'is-invalid': form.errors.has('user_role') }">
                                                                    <option value="Maker" :selected="1">Maker</option>
                                                                    <option value="Checker">Checker</option>
                                                                    <option value="Approver">Approver</option>
                                                            </select>
                                                            <has-error :form="form" field="user_role"></has-error>
                                                        </div>
                                                        <div class="form-group">
                                                            <input v-model="form.user_name" type="text" 
                                                                name="user_name" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('user_name') }" placeholder="Name" required maxlength="40">
                                                            <label for="user_name" class="absolute-label">Name <em class="required">*</em></label>
                                                            <has-error :form="form" field="user_name"></has-error>
                                                        </div>
                                                        <div class="form-group">
                                                            <input v-model="form.user_cnic" type="number" min="0" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" 
                                                                name="user_cnic" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('user_cnic') }" placeholder="CNIC" required maxlength="13">
                                                            <label for="user_cnic" class="absolute-label">CNIC <em class="required">*</em></label>
                                                            <has-error :form="form" field="user_cnic"></has-error>
                                                        </div>
                                                        <div class="form-group">
                                                            <input v-model="form.user_mobile" type="number" min="0" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                                name="user_mobile" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('user_mobile') }" placeholder="Contact Number" required maxlength="13">
                                                            <label for="user_mobile" class="absolute-label">Contact Number <em class="required">*</em></label>
                                                            <has-error :form="form" field="user_mobile"></has-error>
                                                        </div>
                                                        <div class="form-group">
                                                            <input v-model="form.user_email" type="email" 
                                                                name="user_email" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('user_email') }" placeholder="Email" required maxlength="40">
                                                            <label for="user_email" class="absolute-label">Email <em class="required">*</em></label>
                                                            <has-error :form="form" field="user_email"></has-error>
                                                        </div>
                                                        <!-- <div class="form-group">
                                                            <input v-model="form.user_password" type="password" 
                                                            id="password"
                                                                name="user_password" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('user_password') }" placeholder="Password" required min="8" maxlength="20">
                                                            <i class="far fa-eye" id="togglePassword" @click="togglePassword()"></i>
                                                            <label for="user_password" class="absolute-label">Password <em class="required">*</em></label>
                                                            <has-error :form="form" field="user_password"></has-error>
                                                        </div>
                                                        <div class="form-group">
                                                            <input v-model="form.user_password_confirmation" type="password" id="password_confirmation" 
                                                                name="user_password_confirmation" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('user_password_confirmation') }" placeholder="Confirm Password" required min="8" maxlength="20" >
                                                            <label for="user_password_confirmation" class="absolute-label">Confirm Password <em class="required">*</em></label>
                                                            <has-error :form="form" field="user_password_confirmation"></has-error>
                                                        </div> -->
                                                        <div class="row cnic-holder">
                                                            <div class="col-md-12">
                                                                <div class="form-group upload-outer">
                                                                    <span class="upload-title"> CNIC Front - Upload </span>
                                                                    <input type="file" @change="uploadPaymentSlip($event,'new_cnic_front','user_cnic_front')" class="file-up-btn" accept="image/png, image/jpg, image/jpeg" id="new_cnic_front" required/>
                                                                    <label for="new_cnic_front" class="btn-upload-file">Upload <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Accepted formats: JPEG, JPG or PNG"></i></label>
                                                                    <span class="uploaded-file"></span>
                                                                    <label for="new_cnic_front" class="btn-change-file hide"><img src="/images/cross.png" alt=""></label>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                    <div class="form-group upload-outer">
                                                                        <span class="upload-title"> CNIC Back - Upload </span>
                                                                        <input type="file" @change="uploadPaymentSlip($event,'new_cnic_back','user_cnic_back')" class="file-up-btn" accept="image/png, image/jpg, image/jpeg" id="new_cnic_back" required/>
                                                                        <label for="new_cnic_back" class="btn-upload-file">Upload <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Accepted formats: JPEG, JPG or PNG"></i></label>
                                                                        <span class="uploaded-file"></span>
                                                                        <label for="new_cnic_back" class="btn-change-file hide"><img src="/images/cross.png" alt=""></label>
                                                                    </div>
                                                            </div>
                                                        </div>
                                                        <div class="btn-holder text-right pb-lg-5 pb-3">
                                                            <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
                                                            <button type="submit" class="btn-submit" id="add_user_btn">Submit</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="btn-holder text-right pb-lg-5 pb-3">
                                        <router-link :to="{path: '/companyDocuments/' + companyId}" class="btn mr-2 btn-cancel">Previous</router-link>
                                        <button type="button" @click="submitApplication()" id="finish_btn" class="btn-submit">Finish</button>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="crud_company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                new_generated_password: this.generatePassword(),
                form: new Form({
                    fromWeb: 1,
                    user_role: '',
                    user_name: '',
                    user_cnic: '',
                    user_mobile: '',
                    user_email: '',
                    user_password: this.new_generated_password,
                    user_password_confirmation: this.new_generated_password,
                    user_cnic_front: '',
                    user_cnic_back: ''
                }),
                crud_company: null,
                required_documents: null,
                company_details: [],
                uploaded_documents: [],
                company_users: [],
                companyId:'',
                popup_image_path:''
            }
        },
        methods: {
            getOnboardUserDetails(){
                axios.post('/apiV2/digitalOnboarding/getOnboardingUserDetails',{companyId:this.companyId})
                .then(res => {
                    if(res.status == 200){
                        if ( res.data.code == 200 ) {
                            this.company_details = res.data.data.company[0];
                            this.company_users = res.data.data.company;
                            this.cnic_bucket_path = res.data.data.cnic_bucket_path;
                            this.documents_bucket_path = res.data.data.documents_bucket_path;
                            setTimeout(function () {
                                $(".uploaded-file").html('');
                                $(".btn-upload-file").html("Upload <i class='fas fa-question-circle' data-toggle='tooltip' data-placement='top' title='Accepted formats: JPEG, JPG or PNG'></i>").removeClass('showimage');
                            },500);
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            } else {
                            this.showAlertBox('error','Error to load form data');
                        }
                        
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
                $(this.$el).find('.selectpicker').selectpicker('refresh');
            },
            view_image(image_path){
                this.popup_image_path = image_path;
                $('#popupModal').modal('show');  
            },
            downloadImg(responseUrl){
                var link = document.createElement('a');
                link.href = responseUrl;
                link.target = "_blank";
                link.download = 'Download.jpg';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            addCompanyUsers() {
                this.disableButton('add_user_btn','Submitting…',true);
                let newForm=new FormData();
                newForm.append('companyId',this.companyId);     
                $.each(this.form, (key, value) => {
                    newForm.append(key,value);     
                });
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                axios.post('/apiV2/digitalOnboarding/addCompanyUsers',newForm, config)
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == '200'){
                                this.getOnboardUserDetails();
                                $('#add_new_user_modal').modal('hide');  
                                this.showToastBox('success', 'User successfully added to company.');
                                if (res.data.email_sent == 0) {
                                    var new_user_message = 'Your company is being reviewed right now. Once approved, the portal credentials will be shared with the handlers.'
                                    $("#new_user_created_before_approval_text").html(new_user_message);
                                    $('#new_user_created_before_approval').appendTo("body").modal('show');
                                }
                                this.form.reset();
                                $(".uploaded-file").html('');
                                $(".btn-upload-file").html("Upload <i class='fas fa-question-circle' data-toggle='tooltip' data-placement='top' title='Accepted formats: JPEG, JPG or PNG'></i>").removeClass('showimage');
                                this.disableButton('add_user_btn','Add New User',false);

                                this.$Progress.finish();
                            }else{
                                this.disableButton('add_user_btn','Add New User',false);
                                this.showAlertBox('error', res.data.msg);
                                this.$Progress.finish();
                            }
                        }else{
                            this.disableButton('add_user_btn','Add New User',false);
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in you form data');
                        }
                    }).then(res=>{
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(error => {
                        this.disableButton('add_user_btn','Add New User',false);
                        var error_msg = '';

                        error_msg = 'Please provide following details:'+'\n';     

                        $.each(error.response.data.errors, (key, value) => {
                            error_msg += value +'\n';     
                        });
                        this.$Progress.fail();
                        this.showAlertBox('error',error_msg);
                    });

            },
            uploadPaymentSlip(e, id, name) {

                var fileName = e.target.files[0].name;
                var fileExt = e.target.files[0].type;

                $("#"+id).siblings(".uploaded-file").html(fileName);
                $("#"+id).siblings(".btn-change-file").removeClass('hide');
                $("#"+id).siblings(".btn-upload-file").html("").addClass('showimage').prepend('<img src="/images/tick-white.png" alt="">');
                let self=this;
                var files = e.target.files || e.dataTransfer.files;
                if(files.length >0){
                    const new_object_value = {
                        [name]: e.target.files[0]  
                    };
                    Object.assign(this.form,new_object_value);
                         
                }else{
                    const new_object_value = {
                        [name]: ''  
                    };
                    Object.assign(this.form,new_object_value);
                }
            },
            submitApplication() {
                this.disableButton('finish_btn','Submitting…',true);
                this.$Progress.start();
                axios.post('/apiV2/digitalOnboarding/submitOnboardingApplication',{companyId:this.companyId})
                .then(res => {
                    if(res.status == 200){
                        if ( res.data.code == 200 ) {
                            if(res.data.is_super_admin == 1)
                            {
                                this.$router.push('/allCompanies');
                                this.showToastBox('success', res.data.msg);
                                this.$Progress.finish();
                            } else {
                                var finish_message = 'Company onboarding request submitted successfully! <br> After verification you will be notified by email to login to your account.'
                                $("#finish_onboarding_modal_text").html(finish_message);
                                $('#finish_onboarding_modal').appendTo("body").modal('show');
                                this.showToastBox('success', res.data.msg);
                                this.$Progress.finish();
                                this.disableButton('finish_btn','Finish',false);
                            }

                        } else {
                            this.disableButton('finish_btn','Finish',false);
                            this.showAlertBox('error','Error to load form data');
                        }
                        
                        this.$Progress.finish();
                    }else{
                        this.disableButton('finish_btn','Finish',false);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .catch(err => {
                    this.disableButton('finish_btn','Finish',false);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            togglePassword(){
                const togglePassword = document.querySelector('#togglePassword');
                const password = document.querySelector('#password');
                const cpassword = document.querySelector('#password_confirmation');
                const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
                password.setAttribute('type', type);
                cpassword.setAttribute('type', type);
                // toggle the eye / eye slash icon
                togglePassword.classList.toggle('fa-eye-slash');
            }
        },
        mounted() {
            this.crud_company = true;
            this.$Progress.start();
            this.companyId = this.$route.params.id;
            this.getOnboardUserDetails();
            this.$Progress.finish();
            // this.$Progress.start();
            // this.can('crud_company').then(result => {
            //     this.crud_company = result.crud_company;
            // }).then(result => {
            //     if(this.crud_company == true){
            //         this.companyId = this.$route.params.id;
			// 		this.getOnboardUserDetails();
            //         this.$Progress.finish();
            //     }else{
            //         this.$Progress.finish();
            //     }
            // });
        },
    }
</script>
